export enum UserType {
  Contact,
  Employee,
  Facilitator,
  Learner,
  Mentor,
}
